import Layout from '@/layout'
const routesMap = {
  layout: Layout,
  sys:()=>import('@/views/sysManage/roleList'),
  menuList:()=>import('@/views/sysManage/menuList'),
  roleList:()=>import('@/views/sysManage/roleList'),
  adminList:()=>import('@/views/sysManage/adminList'),
  accountList:()=>import('@/views/sysManage/accountList'),
  dataCollocation:()=>import('@/views/sysManage/dataCollocation'),
  commission:()=>import('@/views/sysManage/commission'),
  // 数据量监控
  developer:()=>import('@/views/developer/index'),
  developerIndex:()=>import('@/views/developer/index'),
  monitor:()=>import('@/views/developer/monitor'),
  reportMonitor:()=>import('@/views/developer/reportMonitor'),
  staMonitor:()=>import('@/views/developer/staMonitor'),
  balanceMonitor:()=>import('@/views/developer/balanceMonitor'),

  //Sta管理
  sta:()=>import('@/views/sta/staOrder'),
  staOrder:()=>import('@/views/sta/staOrder'),
  productRel:()=>import('@/views/sta/productRel'),
  shopRel:()=>import('@/views/sta/shopRel'),
  taskManage:()=>import('@/views/taskManage/taskList'),
  taskList:()=>import('@/views/taskManage/taskList'),

  //交易排名
  report:()=>import('@/views/report/categoryRank'),
  categoryRank:()=>import('@/views/report/categoryRank'),
  weightReportList:()=>import('@/views/report/weightReportList'),
  tradingRank:()=>import('@/views/report/tradingRank'),
  merchantRank:()=>import('@/views/report/merchantRank'),

  //运营分析
  analysis:()=>import('@/views/analysis/shopAnalysis'),
  shopAnalysis:()=>import('@/views/analysis/shopAnalysis'),
  categoryAnalysis:()=>import('@/views/analysis/categoryAnalysis'),

  //补打报表
  print:()=>import('@/views/print/latePrint'),
  latePrint:()=>import('@/views/print/latePrint'),
  outputValue:()=>import('@/views/print/outputValue'),
  costList:()=>import('@/views/print/costList'),
  onlinePro:()=>import('@/views/print/onlinePro'),
  diretorManager:()=>import('@/views/print/diretorManager'),
  logistics:()=>import('@/views/print/logistics'),
  printSum:()=>import('@/views/print/printSum'),
  hotMap:()=>import('@/views/print/hotMap'),
  mileage:()=>import('@/views/print/mileage'),
  proUpRate:()=>import('@/views/print/proUpRate'),
  productVsCategory:()=>import('@/views/print/productVsCategory'),
  productCheck:()=>import('@/views/print/productCheck'),


  //离场登记分析
  outReg:()=>import('@/views/outReg/regIndex'),
  regIndex:()=>import('@/views/outReg/regIndex'),
  regBatch:()=>import('@/views/outReg/regBatch'),
  regShop:()=>import('@/views/outReg/regShop'),
  unrecord:()=>import('@/views/outReg/unrecord'),
  outProp:()=>import('@/views/outReg/outProp'),
  orderRegister:()=>import('@/views/outReg/orderRegister')

}
// 动态路由转树结构
export function routesToTree(arr) {
  var arrs = []
  arr.forEach(item => {
    item.name = item.title;
    item.hidden = item.hidden == 2 ? true:false;
    item.meta = {
      title: item.title,
      icon: item.icon,
      affix: item.affix == 2 ? true : false,
      noCache: item.noCache == 2 ? true : false
    };
    if (item.parentId==0) {
      arrs.push(item)
    }
  })

  return arr.reduce((h, m) => {
    if (m.parentId != 0) {
      foo(h, m)
    }

    function foo(arr, cur) {
      arr.forEach(item => {
        if (item.id === cur.parentId) {
          if (!item.children) {
            item.children = []
          }
          item.children.push(cur)
        } else if (item.children) {
          foo(item.children, cur)
        }
      })
    }

    return h
  }, arrs)
}

// map对后台数据做路由映射
export function getMapRoutes(menuList){
  if(!menuList&&menuList.length===0)return [];
  menuList.forEach(item=>{
    item.component = routesMap[item.component];
  })
  return menuList;
}



// WEBPACK FOOTER //
// ./src/router/asyncRoutes.js